import { stdCouleurBleu } from '@commonStyle';
import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  fabContainer: {
    position: 'absolute',
    bottom: '2%',
    right: '2%',
    zIndex: 9000,
  },
  fab: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: stdCouleurBleu,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
      },
      android: {
        elevation: 8,
      },
      web: {
        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
      },
    }),
  },
  fabPressed: {
    backgroundColor: '#0056CC',
    transform: [{ scale: 0.95 }],
  },
  fabIcon: {
    color: '#FFFFFF',
  },
})